module.exports = __webpack_public_path__ + "static/media/bank-note-01.275ec521.svg";